import { CommonModule } from '@angular/common';
import { Component, OnInit, ViewChild, inject, OnDestroy } from '@angular/core';
import { MatCardModule } from '@angular/material/card';
import { MatMenuModule } from '@angular/material/menu';
import { MatSidenavModule } from '@angular/material/sidenav';
import { ActivatedRoute } from '@angular/router';
import { boxInfo } from '../../../../modal/boxInfo';
import { Router, RouterLink, RouterModule, RouterOutlet } from '@angular/router';
import { orgao } from '../../../../modal/regional/orgao';
import { OrgaoService } from '../../../../service/orgao.service';
import { FormsModule } from '@angular/forms';
import {MatPaginatorModule, PageEvent} from '@angular/material/paginator';
import { MatDialog } from '@angular/material/dialog';
import { ConfirmDialogComponent } from '../../dialog/confirmdialog.component';
import { AuthService } from '../../../../service/auth.service';
import { AlertaService } from '../../../../utilidades/alerta.service';
import { fromEvent, Subscription, combineLatest } from 'rxjs';
import { map, startWith } from 'rxjs/operators';
import { parametroHeader } from '../../../../modal/parametroHeader';
import { ParametroHeaderService } from '../../../../service/parametroHeader.service';
@Component({
  selector: 'app-cadastro-listagem-parametro-header',
  standalone: true,
  imports: [
    MatSidenavModule,
    MatCardModule,
    MatMenuModule,
    CommonModule,
    RouterLink,
    RouterOutlet,
    RouterModule,
    FormsModule,
    MatPaginatorModule
  ],
  templateUrl: './cadastro-listagem-parametro-header.component.html',
  styleUrl: './cadastro-listagem-parametro-header.component.scss'
})

export class CadastroListagemParametroHeaderComponent implements OnInit, OnDestroy {
  data = [];
  public listaOrg: parametroHeader[] = [];
  novoItem: parametroHeader = new parametroHeader();
  pesquisaDesc: string  = "";
  pesquisaOrg: string  = "";
  pesquisaCodCentralizado: string  = "";
  pesquisaCodigo: string  = "";

  pageIndex = 0;
  pageSize = 10;
  totalPages = 1;
  pageSizeOptions = [5, 10, 25];

  hidePageSize = false;
  showPageSizeOptions = true;
  showFirstLastButtons = true;
  disabled = false;
  subeButtonAdd= false;
  private sub?: Subscription;
  constructor(
    private route: ActivatedRoute, public alertaService: AlertaService,
    private router: Router,
    private ParametroHeaderService: ParametroHeaderService,
    public dialog: MatDialog,
    private authService: AuthService) {
      const resize$ = fromEvent(window, 'resize').pipe(
        map(() => window.innerWidth), // pega largura da tela
        startWith(window.innerWidth)  // emite o valor inicial
      );
  
      this.sub = combineLatest([
        this.alertaService.isVisivel(),
        resize$
      ]).subscribe(([visivel, largura]) => {
        console.log('Alerta visível?', visivel, '| Largura da tela:', largura);
  
        if (visivel && largura < 570) {
          this.subeButtonAdd = true;
        } else {
          this.subeButtonAdd = false;
        }
      });

    try {
      let login = localStorage.getItem('login');
      if (login == null || login == undefined)
        this.router.navigate(['/iniciar']);
    }
    catch (ex) {
      this.router.navigate(['/iniciar']);
    }
  }
  ngOnInit() {
    this.Pesquisa();
  }

  MudaFiltro()
  {
    this.pageIndex =0;
    this.Pesquisa()
  }

  Pesquisa() {
    this.listaOrg = [];
    console.log(this.pesquisaCodCentralizado)
    this.ParametroHeaderService.get().pipe(
    ).subscribe((response) => {
      this.data = response["retorno"];
      let i = 0;
     
      this.data.forEach(element => {
        i++;
        let p = new parametroHeader(element['id'], element['sistema'], element['width'],
         element['height'], element['url_css'], element['foto'], element['alt'], element['css'], element['nome']
         , element['tipo'], element['periodoEleitoral'], element['ativo']);
        this.listaOrg.push(p)
      });
    });
  }

  obterMaiorCodigo(): number {
    let maiorCodigo = -Infinity; // Inicializa com um valor muito baixo
    for (const objeto of this.listaOrg) {
      let id = Number.parseInt((objeto.id));
        if (id > maiorCodigo) {
          maiorCodigo = id;
        }
    }
    //console.log(maiorCodigo)
    return maiorCodigo+1;
  }

  pageEvent: PageEvent | undefined;

  handlePageEvent(e: PageEvent) {
    this.pageEvent = e;
    this.totalPages = e.length;
    this.pageSize = e.pageSize;
    this.pageIndex = e.pageIndex;
    this.Pesquisa();
  }

  setPageSizeOptions(setPageSizeOptionsInput: string) {
    if (setPageSizeOptionsInput) {
      this.pageSizeOptions = setPageSizeOptionsInput.split(',').map(str => +str);
    }
  }

  sistemaCheck(sistema: string)
  {
    if(sistema == "SALA_SITUACAO")
      return true;
    else
      return false;
  }


  excluirItem(id: string | null): void {
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      data: { title: 'Confirmação', message: 'Tem certeza que deseja excluir?' }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        if (id != undefined) {
          this.ParametroHeaderService.deleteItem(id?.toString()).subscribe(
            (response) => {
              console.log('Item excluído com sucesso!');
              this.Pesquisa();
            },
            (error) => {
              console.error('Erro ao excluir o item:', error);
            }
          );
        }
      }
    });

  }

  validarRole(){
    let role = this.authService.role();
    if(role == 'superuser'){
        return true;
    }
    return false;
  }
  validarRoleSuper(){
    let role = this.authService.role();
    if(role == 'superuser' || role == 'superintendencia'){
        return true;
    }
    return false;
  }

  ngOnDestroy() {
    this.sub?.unsubscribe();
  }
}
